import React, { useState } from "react";
import useTable from "../../../components/useTable";
import ModalTasasConexos from "./ModalTasasConexos";
//UI
import { Checkbox, Input, Textarea } from "../../../ui/inputs/Input";
import { DangerButton, InfoButton, PrimaryButton, SuccessButton, WarningButton } from "../../../ui/buttons/Button";
import ModalTasas from "./ModalTasas";

const headCells = [
  {
    id: "codigo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "SEC.",
    textAlign: "center",
  },
  {
    id: "descripcion",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "PROG.",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "SPRO.",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "PROY.",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "ACT.",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "PART.",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "GEN.",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "ESP.",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "SUB.",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "ORD.",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "CONCEPTO",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "DISPONIBLE Bs.",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "MONTO DE LA OBRA",
    textAlign: "center",
  },
];

export default function FacturarTasasOMPU({ setTabla }) {
  const [mostrarTasas, setMostrarTasas] = useState(false);
  const [mostrarTasasConexos, setMostrarTasasConexos] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting} =
    useTable(records, headCells, filterFn);

  return (
    <div className="col-10 m-0 p-2 border rounded d-flex flex-wrap">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
        <h3 className="m-0">Facturar Tasas Ingenieria</h3>
        <a
          type="button"
          className="fw-bold text-light fs-6"
          onClick={() => setTabla(0)}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </header>
      <div className="col-12 m-0 my-2 p-0 d-flex align-items-center gap-2">
        <div className="col-auto m-0 p-0">
          <InfoButton icon = 'fa-percent' onClick = {() => setMostrarTasas(true)}>
            Tasas
          </InfoButton>
        </div>
        <div className="col-auto m-0 p-0 d-flex gap-2">
          <span className="fw-bold">Tipo de Contribuyente:</span>
          <div>
            <Checkbox label="regular" id="regular" />
          </div>
        </div>
      </div>
      <div className="col-12 m-0 p-0 d-flex">
        <div className="col-11 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={index} >
                    
                  </tr>
                ))}
            </tbody>
          </TblContainer>
        </div>
        <div className="col-1 m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2">
          <div className="col-auto m-0 p-0">
            <DangerButton icon="fa-trash-alt m-0" />
          </div>
          <div className="col-auto m-0 p-0">
            <PrimaryButton icon="fa-percent m-0" onClick={() => setMostrarTasasConexos(true)} />
          </div>
        </div>
      </div>
      <div className="col-8 m-0 p-0">
        <Textarea label="Detalle de la Factura:" style={{ height: 70 }} />
      </div>
      <div className="col-4 m-0 p-0 pl-2">
        <Input label = 'Total a Pagar:'/>
      </div>
      <footer className="col-12 m-0 p-0 d-flex justify-content-end gap-2">
        <WarningButton icon="fa-edit">
          Editar
        </WarningButton>
        <SuccessButton>
          Aceptar
        </SuccessButton>
        <DangerButton icon="fa-trash-alt" onClick={() => setShow(false)}>
          Cancelar
        </DangerButton>
      </footer>
      <ModalTasas show={mostrarTasas} setShow={setMostrarTasas} />
      <ModalTasasConexos show={mostrarTasasConexos} setShow={setMostrarTasasConexos} />
    </div>
  );
}
